import { TITLE_SLOT_HEIGHT, ZONE_ROW_GAP, ZONE_TOP_OFFSET } from "./graphLayout";

export const rowTops = (centerY: number): [number, number] => {
    const rowZeroY = centerY + ZONE_TOP_OFFSET;
    return [rowZeroY, rowZeroY + TITLE_SLOT_HEIGHT + ZONE_ROW_GAP];
};
